<template>
  <div>
    <section role="modal">
      <div
        class="modal fade"
        id="explicacaoModal"
        tabindex="-1"
        role="dialog"
        aria-labelledby="explicacaoModalLabel"
      >
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
              <h4 class="modal-title" id="explicacaoModalLabel">
                Regra de Edição de Endereço
              </h4>
            </div>
            <div class="modal-body">
              <div class="row row-field" style="padding-bottom: 15px;">
                <div class="col-md-12 col-sm-12">
                  <p style="text-align: justify;">
                    Para servidores com <strong>vale transporte</strong> ativo, as alterações serão validadas pela Seção de Controle de Cestas Básicas e Vale Transporte – <strong>SEVALE</strong>.
                  </p>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <botao
                estilo="cheio-verde"
                rotulo="Entendi"
                icone="ok-modal"
                dismiss="modal"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
    <section role="form">
      <div class="main-container container">
        <div class="row">
          <div class="col-md-12">
            <div class="card card-default">
              <div class="card-content">
                <h4>
                  Endereço
                  <span v-if="cadastrado.mostraMultiplosRegistros"
                    >{{ cadastrado.registro | formataRegistro }}</span
                  >&nbsp;
                  <small v-show="cadastrado.pessoa.recebeValeTransporte">
                    <a @click="abreExplicacaoModal()" style="cursor: pointer;"
                      >(Como editar meu endereço?)</a
                    >
                  </small>
                </h4>
                <section role="content">
                  <div v-if="cadastrado.lancamentoPermitido">
                    <div class="row">
                      <div class="col-sm-3">
                        <div class="form-group">
                          <label for="cep">CEP</label>
                          <p>
                            {{ cadastrado.pessoa.endereco.cep | formataCep }}
                          </p>
                        </div>
                      </div>
                      <div class="col-sm-6">
                        <div class="form-group">
                          <label for="logradouro">Logradouro</label>
                          <p>
                            {{
                              cadastrado.pessoa.endereco.tipoLogradouro +
                              ' ' +
                              cadastrado.pessoa.endereco.logradouro
                            }}
                          </p>
                        </div>
                      </div>
                      <div class="col-sm-3 hidden-xs">
                        <div class="form-group">
                          <label for="numero">Número</label>
                          <p>{{ cadastrado.pessoa.endereco.numero }}</p>
                        </div>
                      </div>
                    </div>
                    
                    <div
                      class="row visible-xs-12 hidden-sm hidden-md hidden-lg"
                    >
                      <div class="col-xs-6">
                        <div class="form-group">
                          <label for="numero-xs">Número</label>
                          <p>{{ cadastrado.pessoa.endereco.numero }}</p>
                        </div>
                      </div>
                      <div class="col-xs-6">
                        <div class="form-group">
                          <label for="complemento-xs">Complem.</label>
                          <p>{{ cadastrado.pessoa.endereco.complemento }}</p>
                        </div>
                      </div>
                    </div>
                    
                    <div class="row">
                      <div class="col-sm-3 hidden-xs">
                        <div class="form-group">
                          <label>Complemento</label>
                          <p>{{ cadastrado.pessoa.endereco.complemento }}</p>
                        </div>
                      </div>
                      <div class="col-sm-3">
                        <div class="form-group">
                          <label for>Bairro</label>
                          <p class="textoAlinhadoAoInput">
                            {{ cadastrado.pessoa.endereco.bairro }}
                          </p>
                        </div>
                      </div>
                      <div class="col-sm-3 col-xs-8">
                        <div class="form-group">
                          <label for>Município</label>
                          <p class="textoAlinhadoAoInput">
                            {{ cadastrado.pessoa.endereco.cidade }}
                          </p>
                        </div>
                      </div>
                      <div class="col-sm-3 col-xs-4">
                        <div class="form-group">
                          <label for="proprio">Estado</label>
                          <p class="textoAlinhadoAoInput">
                            {{ cadastrado.pessoa.endereco.uf }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row" v-else>
                    <!--
                    <pms-endereco
                      :api="$root.$data.apiEnderecoUrl"
                      :apiUrl="$root.$data.apiUrl"
                      :parentCep="cadastrado.pessoa.endereco.cep"
                      :parentTipoLogradouro="
                        cadastrado.pessoa.endereco.tipoLogradouro
                      "
                      :parentLogradouro="cadastrado.pessoa.endereco.logradouro"
                      :parentBairro="cadastrado.pessoa.endereco.bairro"
                      :parentMunicipio="cadastrado.pessoa.endereco.cidade"
                      :parentEstado="cadastrado.pessoa.endereco.uf"
                      :parentNumero="cadastrado.pessoa.endereco.numero"
                      :parentComplemento="
                        cadastrado.pessoa.endereco.complemento
                      "
                      :parentGeorreferenciado="
                        cadastrado.pessoa.endereco.georreferenciado
                      "
                      :parentInseridoPeloUsuario="
                        cadastrado.pessoa.endereco.inseridoPeloUsuario
                      "
                      @submitEndereco="gravaPessoaEndereco"
                      @dadosOk="sucesso"
                      @dadosInvalidos="alerta"
                      @dadosInvalidosInfo="alertaInfo" 
                    ></pms-endereco>
                    -->
                    <pms-endereco
                      ref="enderecoComponente" 
                      :api="$root.$data.apiEnderecoUrl"
                      :apiUrl="$root.$data.apiUrl"
                      :parentCep="cadastrado.pessoa.endereco.cep"
                      :parentTipoLogradouro="
                        cadastrado.pessoa.endereco.tipoLogradouro
                      "
                      :parentLogradouro="cadastrado.pessoa.endereco.logradouro"
                      :parentBairro="cadastrado.pessoa.endereco.bairro"
                      :parentMunicipio="cadastrado.pessoa.endereco.cidade"
                      :parentEstado="cadastrado.pessoa.endereco.uf"
                      :parentNumero="cadastrado.pessoa.endereco.numero"
                      :parentComplemento="
                        cadastrado.pessoa.endereco.complemento
                      "
                      :parentGeorreferenciado="
                        cadastrado.pessoa.endereco.georreferenciado
                      "
                      :parentInseridoPeloUsuario="
                        cadastrado.pessoa.endereco.inseridoPeloUsuario
                      "
                      :disabled="!enderecoEditavel"
                      @submitEndereco="gravaPessoaEndereco"
                    ></pms-endereco>
                  </div>
                </section>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section role="controller">
      <div class="container footer-controller">
        <div class="row">
          <div class="col-sm-12 col-md-12">
            <botao
              estilo="vazado-verde-esq"
              rotulo="Voltar"
              icone="voltar"
              @clicado="volta()"
            ></botao>
            <botao
              estilo="cheio-verde-dir"
              rotulo="Avançar"
              icone="avancar"
              :icone-direita="true"
              @clicado="avanca('Contatos')"
            ></botao>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import Vue from 'vue';
import Hash from 'object-hash';
import Botao from '@/components/botao';
import PmsEndereco from '@/components/pms-endereco-aberto-alternativo';
import StringHelper from '@/helpers/StringHelper';
import Endereco from '@/domain/endereco/Endereco.js';

export default {
  name: 'Endereco',

  data() {
    return {
      cadastrado: this.$store.state.funcionarioCadastrado,
      estados: this.$store.state.estados,
      municipios: [],
      enderecos: [],
      dataEnderecoModal: {
        logradouro: {
          nome: '',
        },
        bairro: {
          nome: '',
        },
        cep: '',
        numero: '',
        complemento: '',
      },
      cepInvalido: false,
      mostraLista: false,
      mostraRefresh: false,
      desabilitaCampo: true,
      logradouroInvalido: false,
      proximoComponente: '',
      apiErrors: null,
    };
  },

  computed: {
    situacaoRecad() {
      return this.$store.getters.getSituacaoRecad;
    },
    georreferenciado() {
      return this.cadastrado.pessoa.endereco.georreferenciado
        ? this.cadastrado.endereco.georreferenciado
        : false;
    },
    inseridoPeloUsuario() {
      return this.cadastrado.pessoa.endereco.inseridoPeloUsuario
        ? this.cadastrado.endereco.inseridoPeloUsuario
        : false;
    },
    enderecoEditavel() {
      // Se não recebe vale-transporte, sempre editável
      if (!this.cadastrado.pessoa.recebeValeTransporte) return true;
      // Se recebe vale-transporte, só entre 16/07/2025 e 15/08/2025
      const hoje = new Date();
      const inicio = new Date('2025-05-06T00:00:00');
      const fim = new Date('2025-08-15T23:59:59');
      // A partir de 16/08/2025, deixar o endereço apenas para consulta.
      if (hoje.getTime() > fim.getTime()) return false;
      return hoje.getTime() >= inicio.getTime() && hoje.getTime() <= fim.getTime();
    },
  },

  methods: {
    abreExplicacaoModal() {
      jQuery('#explicacaoModal').modal('show');
    },
    sucesso(sucesso) {
      this.$root.$refs.toastr.s(sucesso, 'Sucesso');
    },
    alerta(alerta) {
      this.$root.$refs.toastr.e(alerta, 'Atenção');
    },
    alertaInfo(alerta, informacao) {
      this.$root.$refs.toastr.Add({
        title: 'Atenção',
        msg: alerta,
        type: 'error',
        timeout: 6000,
      });
      setTimeout(() => {
        this.$root.$refs.toastr.i(informacao, 'Para prosseguir');
      }, 1000);
    },
    gravaPessoaEndereco(editado) {
      try {
    editado.cidade = JSON.parse(JSON.stringify(editado.municipio));
    editado.uf = JSON.parse(JSON.stringify(editado.estado));
    delete editado.municipio;
    delete editado.estado;
    editado.numero = parseInt(editado.numero);
    this.cadastrado.pessoa.endereco = editado;
    this.tiraAcentuacao(this.cadastrado.pessoa.endereco);
    this.setAnexos(this.cadastrado, this.$store.state.cadastroModelo);
    this.$store.commit('setFuncionarioCadastrado', this.cadastrado);
    return true;
  } catch (error) {
    console.error('Error saving address:', error);
    this.$root.$refs.toastr.e('Erro ao salvar endereço', 'Erro');
    return false;
  }
    },
    tiraAcentuacao(endereco) {
      let campos = [
        endereco.bairro,
        endereco.cidade,
        endereco.complemento,
        endereco.logradouro,
        endereco.tipoLogradouro,
      ];
      let index = 0;

      campos.map(element => {
        if (StringHelper.verificaCaracterEspecial(element)) {
          campos[index] = StringHelper.limpaCaracterEspecial(element);
          this.$root.$refs.toastr.w(
            'A Atualização Cadastral não aceita acentos e cedilhas. A aplicação já fez as correções necessárias.',
            'Atenção',
          );
        }
        index++;
      });
      this.cadastrado.pessoa.endereco.bairro = campos[0];
      this.cadastrado.pessoa.endereco.cidade = campos[1];
      this.cadastrado.pessoa.endereco.complemento = campos[2];
      this.cadastrado.pessoa.endereco.logradouro = campos[3];
    },
    setAnexos(cadastrado, original) {
      const endereco =
        Hash(cadastrado.pessoa.endereco) != Hash(original.pessoa.endereco)
          ? true
          : false;
      let documentos = [];

      if (endereco)
        documentos.push(
          'Comprovante de Residência recente (com menos de 90 dias)',
        );

      if (cadastrado.documentosExigidos) {
        const novosDocumentos = documentos.filter(
          item => !cadastrado.documentosExigidos.includes(item),
        );
        cadastrado.documentosExigidos = [
          ...cadastrado.documentosExigidos,
          ...novosDocumentos,
        ];
      } else {
        cadastrado.documentosExigidos = [...documentos];
      }
    },
    volta() {
      this.$router.go(-1);
    },
    async avanca(proximoLink) {
      try {
        const enderecoComponent = this.$refs.enderecoComponente;
        await enderecoComponent.salvar();
        this.proximoComponente = proximoLink;
        this.$router.push({ name: proximoLink });
      } catch (error) {
        console.error('Error saving address:', error);
      }
    },
  },

  created() {
    this.$eventBus.$on('salvaAvanca', nomeComponente => {
      this.avanca(nomeComponente);
    });
  },

  mounted() {
    window.scrollTo(0, 0);
  },

  beforeDestroy() {
    this.$eventBus.$off('salvaAvanca');
  },

  components: {
    Botao,
    PmsEndereco,
  },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// index.vue?036a893e